import { useQuery } from '@tanstack/react-query';
import React, { useState } from 'react';
import * as qs from 'qs';
import api from '../../../domain/api';
import ClientDashboardView from './client-dashboard-view';

const EmbeddedClientDashboard = ({ clientId }) => {
  const [queryParams, setQueryParams] = useState({
    page: 1,
    limit: 10,
    include_activities: 'true',
    include_timeline: 'true',
  });

  // Fetch optimized client dashboard data
  const {
    data: dashboardData,
    isLoading: dashboardLoading,
    refetch: refetchDashboard,
  } = useQuery({
    queryKey: ['client_optimized_dashboard', clientId, queryParams],
    queryFn: async () => {
      const query = qs.stringify(queryParams, { encodeValuesOnly: true });
      const resp = await api.get(`/clients/dashboard/${clientId}?${query}`);
      return resp.data;
    },
    keepPreviousData: true,
    staleTime: 1000 * 60 * 2, // 2 minutes
  });

  // Handle filter changes
  const handleFilterChange = (filters) => {
    setQueryParams({ ...queryParams, ...filters });
  };

  // Handle back - for embedded version, we don't need to navigate
  const handleBack = () => {
    // Do nothing - we're embedded in the client view
  };

  if (dashboardLoading) {
    return (
      <div className='text-center py-5'>
        <div className='spinner-border' role='status'>
          <span className='visually-hidden'>Loading dashboard...</span>
        </div>
        <p className='text-muted mt-2'>Loading client dashboard...</p>
      </div>
    );
  }

  if (!dashboardData) {
    return (
      <div className='text-center py-5'>
        <i className='fas fa-chart-line fa-3x text-muted mb-3'></i>
        <h5 className='text-muted'>Dashboard not available</h5>
        <p className='text-muted'>
          Dashboard data for this client is not available at the moment.
        </p>
      </div>
    );
  }

  return (
    <div>
      <ClientDashboardView
        dashboardData={dashboardData}
        onFilterChange={handleFilterChange}
        onBack={handleBack}
        onRefresh={refetchDashboard}
        queryParams={queryParams}
      />

      <style jsx>{`
        .embedded-client-dashboard {
          padding: 20px;
        }

        .embedded-client-dashboard .dashboard-header {
          display: none; /* Hide the header since we're embedded */
        }

        .embedded-client-dashboard .back-btn {
          display: none; /* Hide the back button since we're embedded */
        }

        /* Override some styles for embedded view */
        .embedded-client-dashboard .client-dashboard-container {
          padding: 0;
        }

        .embedded-client-dashboard .client-info h1.client-name {
          display: none; /* Hide client name since it's already shown above */
        }

        .embedded-client-dashboard .client-meta {
          margin-top: 0;
        }
      `}</style>
    </div>
  );
};

export default EmbeddedClientDashboard;
